type DialpadLaunchUrlParams = {
  confirmPhone?: boolean;
  crmLogging?: boolean;
  phoneNumber?: string;
};

export function dialpadLaunchUrl({
  confirmPhone = true,
  crmLogging = true,
  phoneNumber,
}: DialpadLaunchUrlParams = {}): string {
  const confirmPhoneInt = confirmPhone ? 1 : 0;
  const crmLoggingInt = crmLogging ? 1 : 0;

  if (!phoneNumber) {
    return '';
  }

  return `dialpad://${phoneNumber.replace(/\D/g, '')}?confirmPhone=${confirmPhoneInt}&crmLogging=${crmLoggingInt}`;
}
